import { BuyAllPromotion } from './BuyAllPromotion'
import { withBuyAllPromotion } from './withBuyAllPromotion'

const Connected = withBuyAllPromotion(BuyAllPromotion)

export { Connected as BuyAllPromotion }
